import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType, ReferenceType } from '../../../types';
import type { IFormReferenceSelectProps } from './helper';

export const generate = (
  props?: Partial<IFormFieldSchema<IFormReferenceSelectProps>>
): IFormFieldSchema<IFormReferenceSelectProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.OBJECT,
    name: props?.name || id,
    title: props?.title || 'Reference Select',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormReferenceSelect,
    'x-validator': [],
    'x-component-props': {
      referenceType:
        props?.['x-component-props']?.referenceType ||
        ReferenceType.MODEL_INSTANCE,
      modelIds: props?.['x-component-props']?.modelIds,
      searchableFields: props?.['x-component-props']?.searchableFields,
      transformer: props?.['x-component-props']?.transformer || '',
      transformerToInstances:
        props?.['x-component-props']?.transformerToInstances || '',
      placeholder: props?.['x-component-props']?.placeholder,
      allowClear: props?.['x-component-props']?.allowClear ?? true,
      mode: props?.['x-component-props']?.mode,
      size: props?.['x-component-props']?.size,
      disabled: props?.['x-component-props']?.disabled,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
